import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BoardingCertificateCommon } from '@common/interfaces';
import {
  boardingCertificateCommonInitialState,
  BoardingCertificateCommonStore,
  resetBoardingCertificateCommon,
  selectBoardingCertificateCommonState,
  updateBoardingCertificateCommon,
} from '@common/store';

@Injectable({
  providedIn: 'root',
})
export class BoardingCertificateCommonStoreService {
  /** 搭乗証明書共通ストア取得結果イベント */
  private _state$ = this._store.select(selectBoardingCertificateCommonState);

  /**
   * 搭乗証明書共通ストアを取得する
   */
  get model(): typeof boardingCertificateCommonInitialState.model {
    let model = boardingCertificateCommonInitialState.model;

    this._state$.subscribe((state) => (model = state.model)).unsubscribe();

    return model;
  }

  constructor(private _store: Store<BoardingCertificateCommonStore>) {}

  /**
   * 搭乗証明書共通ストアを更新する
   * @param model 搭乗証明書検索条件
   */
  update(model: BoardingCertificateCommon): void {
    this._store.dispatch(updateBoardingCertificateCommon({ model: { ...this.model, ...model } }));
  }

  /**
   * 搭乗証明書共通ストアをリセットする
   */
  reset(): void {
    this._store.dispatch(resetBoardingCertificateCommon());
  }

  /**
   * 搭乗証明書共通ストアをクリアする
   * @param fields クリアするフィールド名
   */
  clear(...fields: (keyof BoardingCertificateCommon)[]): void {
    let model = this.model ?? {};

    fields.forEach((field) => {
      const { [field]: _, ...remain } = model;
      model = remain;
    });

    if (fields.length && Object.keys(model).length) {
      this._store.dispatch(updateBoardingCertificateCommon({ model }));
    } else {
      this.reset();
    }
  }
}
